import type {ApiService} from "~/services/ApiService";
import type {
  FlowTemplate,
  FlowTemplatePaginationResponseObject,
} from '~~/api/models';

export class FlowService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  async getFlowTemplates(page: number = 1, pageSize: number = 15, searchString: string = ''): Promise<FlowTemplatePaginationResponseObject> {
    return this.apiService.get<FlowTemplatePaginationResponseObject>("/api/flow", {
      headers: {
        'X-TENANT-ID': this.apiService.activeTenant as string,
      },
      query: {
        page,
        pageSize,
        searchString,
        sort: 'name:asc',
      }
    });
  }

  async getCompanyFlowTemplates(tenantId: string, page: number = 1, pageSize: number = 15, searchString: string = ''): Promise<FlowTemplatePaginationResponseObject> {
    return this.apiService.get<FlowTemplatePaginationResponseObject>("/api/flow", {
      headers: {
        'X-TENANT-ID': tenantId as string,
      },
      query: {
        page,
        pageSize,
        searchString,
        sort: 'name:asc',
      }
    });
  }

  async getFlowTemplate(flowId: string): Promise<FlowTemplate> {
    return this.apiService.get<FlowTemplate>(`/api/flow/${flowId}`, {
      headers: {
        'X-TENANT-ID': this.apiService.activeTenant as string,
      }
    });
  }

  async createFlowTemplate(flowTemplate: FlowTemplate): Promise<FlowTemplate> {
    return this.apiService.post<FlowTemplate>(`/api/flow`, {
      headers: {
        'X-TENANT-ID': this.apiService.activeTenant as string,
      },
      body: flowTemplate
    });
  }

  async deleteFlowTemplate(flowId: string): Promise<boolean> {
    return this.apiService.delete(`/api/flow/${flowId}`, {
      headers: {
        'X-TENANT-ID': this.apiService.activeTenant as string,
      }
    });
  }

  async updateFlowTemplate(flowId: string, flowTemplate: FlowTemplate): Promise<FlowTemplate> {
    return this.apiService.put<FlowTemplate>(`/api/flow/${flowId}`, {
      headers: {
        'X-TENANT-ID': this.apiService.activeTenant as string,
      },
      body: flowTemplate
    });
  }
}